import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DistributorsComponent } from './distributors/distributors.component';
import { SuperAdminRoutingModule } from './super-admin-routing.module';
import { ManufacturersComponent } from './manufacturers/manufacturers.component';
import { PromotionsComponent } from './promotions/promotions.component';
import { ProductsDepartmentsComponent } from './products-departments/products-departments.component';
import { MaterialsModule } from '../materials/materials.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DistributorComponent } from './distributor/distributor.component';
import { ManufacturerComponent } from './manufacturer/manufacturer.component';
import { AddPromotionComponent } from './promotions/add-promotion/add-promotion.component';
import { DeletePromotionComponent } from './promotions/delete-promotion/delete-promotion.component';
import { AddEditDepartmentComponent } from './products-departments/add-edit-department/add-edit-department.component';
import { DeleteDepartmentComponent } from './products-departments/delete-department/delete-department.component';
import { ManagePlanComponent } from './manage-plan/manage-plan.component';
import { LogosCompanyComponent } from "./logos-company/logos-company.component";
import { AddLogoComponent } from "./logos-company/add-logo/add-logo.component";
import { EllipsisTooltipDirective } from '../shared/directives/ellipsis-tooltip.directive';



@NgModule({
  declarations: [DistributorsComponent, ManufacturersComponent, PromotionsComponent, ProductsDepartmentsComponent,
    DistributorComponent, ManufacturerComponent, AddPromotionComponent, DeletePromotionComponent,
    AddEditDepartmentComponent, DeleteDepartmentComponent, ManagePlanComponent, LogosCompanyComponent, AddLogoComponent],
  imports: [
    SuperAdminRoutingModule,
    CommonModule,
    MaterialsModule,
    FormsModule,
    ReactiveFormsModule,
    EllipsisTooltipDirective
  ]
})
export class SuperAdminModule { }
